<template>
	<div tabindex="0" @keyup.esc="closeAdd()" class="hide-outline">
		<TopPanel
			:units="[$t('floor_view.unit_singular'), $t('floor_view.unit_plural'), $t('floor_view.new')]"
			:pagination="pagination"
			:orderBys="orderBys"
			:orderBy="searchParams.orderBy"
			@toggleAdd="toggleAdd"
			@search="search"
			@orderBy="orderBy"
		/>
		<main class="main-view" @click="closeAdd()">
			<FloorList
				:floors="floors"
				@delete="askToDelete"
				@edit="editFloor"
				@search="getFloors()"
				@navigate="navigate"
			/>
		</main>
		<AddFloor
			v-if="showAdd && isMobile"
			@save="saveFloor"
			@cancel="closeAdd"
			:editFloor="selectedFloor"
		/>
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import FloorList from './components/FloorList';
import AddFloor from './modals/AddFloor';
import DeleteModal from '@/components/DeleteModal';
import TopPanel from '@/components/TopPanel';

export default {
	components: {
		FloorList,
		AddFloor,
		DeleteModal,
		TopPanel
	},
	data() {
		return {
			showAdd: false,
			showDelete: false,
			selectedFloor: {},
		};
	},
	computed: {
		...mapState('floorStore', ['searchParams']),
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('floorStore', ['floors', 'pagination']),
		...mapGetters('buildingStore', ['building']),
		deleteMessage() {
			return this.selectedFloor.name
				? this.$t('floor_view.confirm_delete', { name: this.selectedFloor.name })
				: '';
		},

		orderBys() {
			return [
				{ name: this.$t('common.order_name'), value: 'Name' },
				{ name: this.$t('common.order_created'), value: 'Created' }
			];
		},


	},
	methods: {
		...mapActions('floorStore', [
			'getFloors',
			'createFloor',
			'updateFloor',
			'deleteFloor',
			'setCurrentPage',
			'setPageSize'
		]),
		...mapActions('mapStore', ['setMaps', 'createMap']),
		...mapActions('mapItemStore', ['setMapItems']),
		...mapActions('buildingStore', ['getBuilding']),
		toggleAdd() {
			if (!this.$isAllowedTo('floors_edit')) return;
			if (!this.selectedFloor.name) {
				this.showAdd = !this.showAdd;
			}

			this.selectedFloor = {};
		},
		closeAdd() {
			if (window.getSelection().toString() == '') {
				this.showAdd = false;
				this.selectedFloor = {};
			}

			if (this.showDelete) {
				this.showDelete = false;
				this.selectedFloor = {};
			}
		},
		saveFloor(floor) {
			if (!this.$isAllowedTo('floors_edit')) return;
			if (this.selectedFloor.id) {
				this.updateFloor(floor).then(() => {
					this.showAdd = false;
					this.selectedFloor = {};
				});
			} else {
				floor.buildingId = this.$route.params.buildingId;
				this.createFloor(floor).then(() => {
					this.showAdd = false;
					this.getBuilding(floor.buildingId).then(() => {
						this.createMap({
							floorId: this.building.floors[this.building.floors.length - 1].id,
							name: 'Ritning 1'
						});
					});
				});
			}
		},
		editFloor(floor) {
			if (!this.$isAllowedTo('floors_edit')) return;
			if (this.selectedFloor == floor) {
				this.selectedFloor = {};
				this.showAdd = false;
			} else {
				this.selectedFloor = floor;
				this.showAdd = true;
			}
		},
		askToDelete(floor) {
			if (!this.$isAllowedTo('floors_delete')) return;
			this.showAdd = false;
			Object.assign(this.selectedFloor, floor);
			this.showDelete = true;
		},
		cancelDelete() {
			this.showDelete = false;
			this.selectedFloor = {};
		},
		deleteSelected() {
			if (!this.$isAllowedTo('floors_delete')) return;
			this.deleteFloor(this.selectedFloor).then(() => {
				this.showDelete = false;
				this.selectedFloor = {};
			});
		},
		search(searchValue) {
			this.searchParams.name = searchValue;
			this.getFloors();
		},
		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getFloors();
		},
		paginate(page) {
			this.setCurrentPage(page);
			this.getFloors();
		},
		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.getFloors();
		},
		navigate(floorId) {
			this.setMaps([]);
			this.setMapItems([]);
			this.$router.push({
				name: 'FloorDetailView',
				params: {
					floorId
				}
			});
		}
	},
	created() {
		this.searchParams.buildingId = this.$route.params.buildingId;
		this.getFloors();
	}
};
</script>
